import { ChangeDetectionStrategy, Component, input, InputSignal } from '@angular/core';

@Component({
  selector: 'ui-order-checkout-reference-text',
  imports: [],
  templateUrl: './order-checkout-reference-text.component.html',
  styleUrls: ['./order-checkout-reference-text.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderCheckoutReferenceTextComponent {
  public orderCustomReferenceText: InputSignal<string | undefined> = input();
}
